import React, { useEffect, useState, useRef } from "react";
import Card from "react-bootstrap/Card";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import Table from "react-bootstrap/Table";
import Dettagli from "./DettagliManVenAR";
import axios from "axios";

function WithHeaderStyledExample() {
  const [isLoading, setIsLoading] = useState(true);
  const [percentualeValore, setPercentualeValore] = useState("");
  const [percentualeQta, setPercentualeQta] = useState("");
  const [percentualeNumCli, setPercentualeNumCli] = useState("");
  const [
    percentualeRicercato_disponibile,
    setPercentualeRicercato_disponibile,
  ] = useState("");
  const [mancataVenditaMedia, setMancataVenditaMedia] = useState({});
  const [mancataVenditaAttuale, setMancataVenditaAttuale] = useState({});
  const [quantityOrdered2023, setQuantityOrdered2023] = useState(0);
  const [quantityOrdered2024, setQuantityOrdered2024] = useState(0);
  const [percentuale, setPercentuale] = useState("");
  const [show, setShow] = useState(false);
  const [isError, setIsError] = useState(false);
  const containerRef = useRef(null);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [showModal, setShowModal] = useState(false);


  useEffect(() => {
    const container = containerRef.current;
    const textWidth = container.scrollWidth;
    const containerWidth = container.offsetWidth;

    if (textWidth > containerWidth) {
      const animationDuration = textWidth / 50; // Adjust speed as needed
      container.style.animation = `scrollText ${animationDuration}s linear infinite`;
    }

    return () => {
      container.style.animation = ""; // Clean up animation
    };
  }, [mancataVenditaAttuale.ricercato_disponibile]); // Assicurati di includere mancataVenditaAttuale.ricercato_disponibile come dipendenza

  const COLORS = ["#b81f25", "#585858"];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Definisci la funzione getDateRange prima di utilizzarla
  const getDateRange = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1; // aggiungi 1 perché i mesi partono da 0
    const currentYear = today.getFullYear();

    // Calcola l'anno scorso
    const lastYear = currentYear - 1;

    // Formatta il mese e il giorno corrente con zero a sinistra se necessario
    const formatDigit = (digit) => {
      return digit < 10 ? "0" + digit : digit;
    };

    const formattedCurrentMonth = formatDigit(currentMonth);
    const formattedToday = formatDigit(today.getDate());

    // Costruisci le stringhe per le date
    const currentDateRange = `01/${formattedCurrentMonth}/${currentYear} - ${formattedToday}/${formattedCurrentMonth}/${currentYear}`;
    const lastYearDateRange = `01/${formattedCurrentMonth}/${lastYear} - ${formattedToday}/${formattedCurrentMonth}/${lastYear}`;

    return {
      currentDateRange,
      lastYearDateRange,
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { mese } = res.data.AR;

        const entry2023 = mese.find((entry) => entry.anno === "2025");
        const entry2024 = mese.find((entry) => entry.anno === "2026");

        if (entry2023) {
          setQuantityOrdered2023(entry2023.valore_ordinato);
        }

        if (entry2024) {
          setQuantityOrdered2024(entry2024.valore_ordinato);

          const percentualChange =
            ((entry2024.valore_ordinato - entry2023.valore_ordinato) /
              entry2023.valore_ordinato) *
            100;
          setPercentuale(percentualChange.toFixed(2));
        }

        setIsLoading(false);
      } catch (error) {
        setIsError(true);
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  const formatToEuro = (amount) => {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  };

  const { currentDateRange, lastYearDateRange } = getDateRange(); // Ottieni le date utilizzando la funzione getDateRange

  // Calcola la somma totale dei valori
  // Converti i valori delle quantità in numeri prima di calcolare la somma
  const totalOrders =
    parseFloat(quantityOrdered2023) + parseFloat(quantityOrdered2024);

  // Calcola le percentuali rispetto alla somma totale
  const percent2023 = (quantityOrdered2023 / totalOrders) * 100;
  const percent2024 = (quantityOrdered2024 / totalOrders) * 100;

  //console.log(totalOrders);

  // Struttura dei dati per il grafico
  const data = [
    { name: "2023", value: percent2023 },
    { name: "2024", value: percent2024 },
  ];

useEffect(() => {
  const fetchData = () => {
    axios
      .get("./dati_dashboard.json")
      .then((res) => {
        const { mancata_vendita } = res.data.AR;

        if (mancata_vendita) {
          const media = mancata_vendita.media;
          const attuale = mancata_vendita.attuale;

          setMancataVenditaMedia(media);
          setMancataVenditaAttuale(attuale);

          const diff = attuale.valore - media.valore;
          const percentage = (diff / media.valore) * 100;
          setPercentualeValore(percentage.toFixed(2));

          const diff2 = attuale.qta - media.qta;
          const percentageQta = (diff2 / media.qta) * 100;
          setPercentualeQta(percentageQta.toFixed(2));

          const diff3 = attuale.num_cli - media.num_cli;
          const percentageNum_cli = (diff3 / media.num_cli) * 100;
          setPercentualeNumCli(percentageNum_cli.toFixed(2));

          const diff4 =
            attuale.ricercato_disponibile - media.ricercato_disponibile;
          const percentageRicercato_disponibile =
            (diff4 / media.ricercato_disponibile) * 100;
          setPercentualeRicercato_disponibile(
            percentageRicercato_disponibile.toFixed(2)
          );
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Errore:", err);
        setIsError(true);
      });
  };

  fetchData();
}, []);


  return (
    <>
    <Card className="border-transparent cs ombra hover-effect" onClick={handleShowModal} >

      <Card.Body
        className="d-flex flex-column align-items-center justify-content-center text-center p-2 bg-dark"
        style={{ color: "rgba(241,111,36,1)"}}
      >
        <p className="text-title2 p-1 rounded">
          DETTAGLI VENDITE
        </p>
        <p style={{ fontSize: "0.6em" }} className="fw-bold mb-1">
          confronto al periodo che va dal {currentDateRange} al{" "}
          {lastYearDateRange}
        </p>{" "}
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h5 className=" fw-bold mx-3" style={{ fontSize: "1.1em" }}>
            TOTALE 2025: {formatToEuro(quantityOrdered2023)}{" "}
          </h5>
          <h5 className=" fw-bold mx-3" style={{ fontSize: "1.1em" }}>
            TOTALE 2026: {formatToEuro(quantityOrdered2024)}{" "}
          </h5>
          <p
            className=" fw-bold mb-2"
            style={{
              fontSize: "0.6em",
              margin: 0,
              borderBottom: "1px solid black",
              width: "100%",
            }}
          >
            Confronto mensile annuale: {percentuale}
            {percentuale !== "" && (
              <>
                {parseFloat(percentuale) < 0 ? (
                  <FaArrowTrendDown style={{ color: "red" }} />
                ) : (
                  <FaArrowTrendUp style={{ color: "green" }} />
                )}
              </>
            )}
          </p>
        </div>
        <div className="w-100 card-man-ven">
          <Table
            variant="dark"
            className="text-center"
            style={{ width: "100%", fontWeight: "bold", fontSize: "12px" }}
          >
            <thead>
              <tr>
                <th className="text-start">Mancata vendita</th>
                <th>Media mensile</th>
                <th className="text-end">Trend</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "start" }}>{`${formatToEuro(
                  mancataVenditaAttuale.valore
                )}`}</td>
                <td classname="">
                  {" "}
                  {`${formatToEuro(mancataVenditaMedia.valore)}`}
                </td>
                <td style={{ textAlign: "end" }}>
                  {" "}
                  {percentualeValore}%{" "}
                  {percentualeValore > 0 ? (
                    <FaArrowTrendUp style={{ color: "red" }} />
                  ) : (
                    <FaArrowTrendDown style={{ color: "green" }} />
                  )}
                </td>
              </tr>

              

              <tr>
                <td
                  style={{ textAlign: "start" }}
                >{`Cli: ${mancataVenditaAttuale.num_cli}`}</td>
                <td classname="">{`Cli: ${mancataVenditaMedia.num_cli}`}</td>
                <td style={{ textAlign: "end" }}>
                  {" "}
                  {percentualeNumCli}%{" "}
                  {percentualeNumCli > 0 ? (
                    <FaArrowTrendUp style={{ color: "red" }} />
                  ) : (
                    <FaArrowTrendDown style={{ color: "green" }} />
                  )}
                </td>
              </tr>

              <tr>
                <td style={{ textAlign: "start" }}>
                  <p className="sliding-text">
                  <span className="scrolling-text" ref={containerRef}>
                    {"Dispo di ricerca"}:
                  </span></p>
                  {mancataVenditaAttuale.ricercato_disponibile}%
                </td>
                <td>{mancataVenditaMedia.ricercato_disponibile}%</td>
                <td style={{ textAlign: "end" }}>
                  {percentualeRicercato_disponibile}%{" "}
                  {percentualeRicercato_disponibile > 0 ? (
                    <FaArrowTrendUp style={{ color: "green" }} />
                  ) : (
                    <FaArrowTrendDown style={{ color: "red" }} />
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  <Dettagli showModal={showModal} handleCloseModal={handleCloseModal} />
  </>
  );
}

export default WithHeaderStyledExample;


